/*
 * Module for the DROP Benefit Summary header partial view
*/

rs.module("participant/drop/summary/benefitsummaryheader",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var paymentMethodContainer = $.js(jsSelectors.paymentMethodContainer);

            // show/hide payment method on hover with intent
            paymentMethodContainer.hoverIntent({
                handlerOver: function (event) {
                    paymentMethodContainer.js(jsSelectors.paymentMethodPopup).show();
                },
                handlerOut: function (event) {
                    paymentMethodContainer.js(jsSelectors.paymentMethodPopup).hide();
                },
                hoverOutDelay: 400
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);